/**
 * Created by Carsten Bühler
 * User: CBuehler on 13.11.2015
 * Copyright: xdot GmbH 2015
 */
'use strict';

import LiferayWidgetsReactDispatcher from './dispatcher/LwrDispatcher';

import ReactDOM from 'external/react-dom';

class AppContextClass {

    constructor(){
        this.DEFAULT_LIST_SIZE = 25;
        this.stores = [];
        this.dispatcher = new LiferayWidgetsReactDispatcher();
        this.webApis = {};
        this.websocketUnsupported = false;
        this.contextElements = {};
        if (window.app_context_DO_NOT_USE) {
            console.error('Second app context!', window.app_context_DO_NOT_USE);
        }
        window.app_context_DO_NOT_USE = this;
    }

    registerBundle(bundle){
        console.log('Register bundle', bundle);
        this.webApis = { ...this.webApis, ...bundle.webApis };

        if (bundle.contextElements) {
            Object.keys(bundle.contextElements).forEach(key => {
                this.addContextElement(bundle.contextElements[key], key);
            });
        }
    }

    createStore(StoreClass){
        const store = new StoreClass(this.getDispatcher());
        this.stores.push(store);
        return store;
    }

    getStores(){
        return this.stores;
    }

    getDispatcher(){
        return this.dispatcher;
    }

    getWebApis(){
        return this.webApis;
    }

    addContextElement(element, divId){
        let contextEl = document.getElementById(divId);
        if (!contextEl) {
            contextEl = document.createElement('div');
            contextEl.id = divId;
            document.body.appendChild(contextEl);
        }
        //ToDO maybe we can implement this with Portals?
        return ReactDOM.render(element, contextEl);
    }

    getScopeGroupId(){
        return parseInt(Liferay.ThemeDisplay.getScopeGroupId());
    }

    getUserId(){
        return parseInt(Liferay.ThemeDisplay.getUserId());
    }

    setWebsocketUnsupported(val){
        this.websocketUnsupported = val;
    }

    getWebsocketUnsupported(){
        return this.websocketUnsupported;
    }

    setWebsocketConnected(isWsActiveFktn){
        this.isWsActiveFktn = isWsActiveFktn;
    }

    isWebsocketConnected(){
        return this.isWsActiveFktn && this.isWsActiveFktn();
    }

}

export const AppContext = new AppContextClass();



// WEBPACK FOOTER //
// ./js/app-context.js